//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface AcceptInviteEmailTemplate {
  options?: AcceptInviteEmailTemplateOptions
  design?: string | undefined
  html?: string | undefined
  emailSubject?: string | undefined
}

export interface AcceptInviteEmailTemplateOptions {
  subject?: string | undefined
}

export interface AcceptPartyInviteRequest {
  inviteId?: string
  inviteCode?: string | undefined
}

export interface AcceptPartyInviteResponse {
  buyerPartyId?: string
}

export interface ActivityDto {
  workingStepKey?: WorkingStepKey
  externalCode?: string | undefined
  externalSequenceNumber?: string | undefined
  description?: string | undefined
  primaryWorkingStep?: WorkingStepType
  secondaryWorkingStep?: WorkingStepType
  ratePerDuration?: MoneyPerQuantityDto
  materialTokens?: string[] | undefined
  purchasingLength?: QuantityDto
  purchasingWidth?: QuantityDto
  purchasingHeight?: QuantityDto
  purchasingDimensions?: PurchasingDimensions
  canUploadResourceSpec?: boolean
  hasSpecification?: boolean
  isSelectable?: boolean
  costsCanBeShared?: boolean
  shareRatioBy?: ShareRatioBy
  batchIndependent?: boolean
}

export interface AddActivityArgs {
  id?: string | undefined
  name?: string | undefined
  isDefault?: boolean
  readonly isValid?: boolean
  readonly validationMessage?: string | undefined
  readonly validationDictionary?: { [key: string]: string } | undefined
}

export interface AddAgentArgs {
  name?: string | undefined
  readonly isValid?: boolean
  readonly validationMessage?: string | undefined
  readonly validationDictionary?: { [key: string]: string } | undefined
}

export interface AddAgentIntegrationArgs {
  integrationType?: IntegrationType
  readonly isValid?: boolean
  readonly validationMessage?: string | undefined
  readonly validationDictionary?: { [key: string]: string } | undefined
}

export interface AddKeywordsToPartsArgs {
  rowIds: string[]
  keywords: string[]
}

export interface AddPartyCanBuyFromRequest {
  buyingPartyId?: string
  sellingPartyId?: string
}

export interface AddPartyRequest {
  name?: string | undefined
  coCKey?: string | undefined
  currencyCode?: string | undefined
  hasSubscription?: boolean | undefined
  id?: string | undefined
}

export interface AddPartyUserRequest {
  firstName?: string | undefined
  lastName?: string | undefined
  email?: string | undefined
  role?: string | undefined
}

export interface AddRegressionTestsArgs {
  rowIds?: string[] | undefined
}

export interface AddServicesApiUserRequest {
  partyId?: string
  userId?: string | undefined
}

export interface AddTenantRequest {
  identifier?: string | undefined
  name?: string | undefined
  partyId?: string
}

export interface AddUserRequest {
  firstName?: string | undefined
  lastName?: string | undefined
  email?: string | undefined
}

export interface AdditionalWorkingStepDto {
  jsonSchema?: string | undefined
  uiSchema?: string | undefined
  formData?: any | undefined
}

export interface AddressBookDto {
  id?: string
  code?: string | undefined
  companyName?: string | undefined
  postalStreet?: string | undefined
  postalHouseNumber?: string | undefined
  postalHouseNumberAddition?: string | undefined
  postalZipCode?: string | undefined
  postalCity?: string | undefined
  postalStateOrProvince?: string | undefined
  postalCountryCode?: string | undefined
  postalCountryName?: string | undefined
  phone?: string | undefined
  email?: string | undefined
  website?: string | undefined
  bicOrSwiftCode?: string | undefined
  iban?: string | undefined
  vatNumber?: string | undefined
  vatRatio?: QuantityDto
  coCNumber?: string | undefined
  coCBranchNumber?: string | undefined
  coCCountryCode?: string | undefined
  coCCountryName?: string | undefined
  showInviteButton?: boolean
  showReSendInviteButton?: boolean
  showRevokeInviteButton?: boolean
  showRevokeAccessButton?: boolean
  hasPortalAccess?: boolean
  languageCode?: string | undefined
  languageDescription?: string | undefined
  invitation?: InvitationDto
  segment?: string | undefined
  tags?: string[] | undefined
}

export interface AddressBookImportErrorDto {
  rowNumber?: number
  errors?: string[] | undefined
}

export interface AddressBookImportJobDto {
  id?: string
  startTime?: Date
  finishedTime?: Date | undefined
  status?: AddressBookImportJobDtoStatus
  total?: number
  inserted?: number
  updated?: number
  skipped?: number
  deleted?: number
  errors?: AddressBookImportErrorDto[] | undefined
}

export enum AddressBookImportJobDtoStatus {
  Running = 'Running',
  Succeed = 'Succeed',
  ContainsErrors = 'ContainsErrors',
}

export interface AddressDto {
  street?: string | undefined
  houseNumber?: string | undefined
  houseNumberAddition?: string | undefined
  zipCode?: string | undefined
  city?: string | undefined
  stateOrProvince?: string | undefined
  country?: CountryDto
  readonly addressAsString?: string | undefined
  type?: AddressType
}

export enum AddressType {
  NotSet = 'NotSet',
  PostalAddress = 'PostalAddress',
  BranchAddress = 'BranchAddress',
  VisitingAddress = 'VisitingAddress',
  DeliveryAddress = 'DeliveryAddress',
}

export interface AgentDto {
  id?: string
  name?: string | undefined
  isDefault?: boolean
  rootDirectory?: string | undefined
  keepAliveInterval?: QuantityDto
  projectStatusExportStates?: ProjectStates[] | undefined
  projectExportStates?: ProjectStates[] | undefined
  availableProjectStates?: ProjectStates[] | undefined
}

export interface AgentIntegrationDto {
  id?: string | undefined
  name?: string | undefined
  integrationType?: IntegrationType
  formData?: any | undefined
  jsonSchemaObjects?: JsonSchemaObjects
}

export enum AggregateLevel {
  NotInitialized = 'NotInitialized',
  Project = 'Project',
  Assembly = 'Assembly',
  PartType = 'PartType',
  CalculatedValues = 'CalculatedValues',
  NestingResults = 'NestingResults',
  Party = 'Party',
  WorkflowEngine = 'WorkflowEngine',
  TestSuite = 'TestSuite',
  System = 'System',
  Agent = 'Agent',
}

export interface AnalyzedArticleDto {
  description?: string | undefined
  code?: string | undefined
  analysis?: string[] | undefined
  keywords?: { [key: string]: KeywordDto[] } | undefined
  dimensions?: DimensionsDto[] | undefined
  hideInPortal?: boolean
}

export interface ApiMetadata {
  page?: number
  pageSize?: number
  totalRecords?: number
  totalPages?: number
}

export interface ArticleCostPriceArgs {
  articleId?: string | undefined
  costPrice?: MoneyPerQuantityDto
  priceScope?: PriceScope
}

export interface ArticleDto {
  id?: string
  code?: string | undefined
  description?: string | undefined
  purchasePrice?: MoneyPerQuantityDto
}

export interface ArticleImportErrorDto {
  rowNumber?: number
  errors?: string[] | undefined
}

export interface ArticleImportJobDto {
  id?: string
  startTime?: Date
  finishedTime?: Date | undefined
  status?: ArticleImportJobDtoStatus
  total?: number
  inserted?: number
  updated?: number
  skipped?: number
  deleted?: number
  errors?: ArticleImportErrorDto[] | undefined
}

export enum ArticleImportJobDtoStatus {
  Running = 'Running',
  Succeed = 'Succeed',
  ContainsErrors = 'ContainsErrors',
}

export interface ArticleManualDiscountArgs {
  discountRatio?: QuantityDto
  discountValue?: MoneyDto
  articleId?: string | undefined
  readonly isValid?: boolean
  readonly validationMessage?: string | undefined
  readonly validationDictionary?: { [key: string]: string } | undefined
}

export interface ArticleManualSurchargeArgs {
  surchargeRatio?: QuantityDto
  surchargeValue?: MoneyDto
  articleId?: string | undefined
  readonly isValid?: boolean
  readonly validationMessage?: string | undefined
  readonly validationDictionary?: { [key: string]: string } | undefined
}

export interface AssemblyDto {
  id?: string
  partTypeIds?: string[] | undefined
  hasGeometry?: boolean
  name?: string | undefined
  thumbnail3d?: string | undefined
  threeDModelPath?: string | undefined
  financial?: FinancialDto
  attachments?: BoMItemAttachmentDto[] | undefined
  partTypeWorkingStepDtos?: WorkingStepDto[] | undefined
  assemblyWorkingStepDtos?: WorkingStepDto[] | undefined
  originalFileName?: string | undefined
  isManufacturable?: boolean
  manufacturableStatus?: string | undefined
  manufacturableResult?: string | undefined
  isExportedToErp?: boolean
  exportedToErpStatus?: string | undefined
  exportedToErpResult?: string | undefined
  externalUrl?: string | undefined
  comment?: string | undefined
  analysisStatus?: string | undefined
  analysisErrorMessage?: string | undefined
  canBeEdit?: boolean
}

export interface AssemblyHeaderDto {
  assembly?: AssemblyDto
}

export interface AssemblySimplifyDto {
  assemblyId?: string
  partIds?: string[] | undefined
}

export interface AssemblyStructureDto {
  id?: string
  parentId?: string
  assembly?: AssemblyDto
  partTypeRows?: RowDto[] | undefined
  workingStepDtos?: WorkingStepDto[] | undefined
  subAssemblies?: AssemblyStructureDto[] | undefined
  originalFileName?: string | undefined
}

export interface AssignPartyRoleRequest {
  userId?: string | undefined
  role?: string | undefined
  partyId?: string
}

export interface AssignSystemRoleRequest {
  userId?: string | undefined
  role?: string | undefined
}

export interface AuthUserDto {
  id?: string | undefined
  fullName?: string | undefined
  firstName?: string | undefined
  lastName?: string | undefined
  email?: string | undefined
  emailVerified?: boolean | undefined
  picture?: string | undefined
}

export interface BatchUpdateBomItemsArgs {
  bomItemUpdates?: BomItemUpdateRequestDto[] | undefined
}

export interface BendingDto {
  numberOfBendGroups?: number | undefined
  numberOfBendGroupsSide1?: number | undefined
  numberOfBendGroupsSide2?: number | undefined
  bendXTurns?: number | undefined
  bendYTurns?: number | undefined
  bendZTurns?: number | undefined
}

export interface BoMDto {
  assemblyHeaders?: AssemblyHeaderDto[] | undefined
  materialHeaders?: MaterialHeaderDto[] | undefined
  assemblyStructures?: AssemblyStructureDto[] | undefined
  partTypeRows?: RowDto[] | undefined
  priceSummaries?: PriceSummaryDto[] | undefined
  routingHeader?: RoutingHeaderDto[] | undefined
}

export interface BoMItemAttachmentDto {
  fileName?: string | undefined
  scope?: string | undefined
  dateCreated?: Date | undefined
  originalFileName?: string | undefined
}

export interface BoMItemDiscountArgs {
  discountPercentage?: number
}

export interface BoMItemSurchargeArgs {
  surchargePercentage?: number
}

export interface BomItemUpdateRequestDto {
  bomItemId?: string
  quantity?: number
  keywords?: { [key: string]: KeywordDto[] } | undefined
  comment?: string | undefined
}

export interface BusinessRulesResponse {
  isRuleEmpty?: boolean
  isRuleValid?: boolean
  output?: string | undefined
  clientInvalidData?: any | undefined
}

export interface CadFilePattern {
  order?: number
  property?: CadFilePatternProperties
  pattern?: string | undefined
}

export enum CadFilePatternProperties {
  NotInitialized = 'NotInitialized',
  Thickness = 'Thickness',
  Quantity = 'Quantity',
  Quality = 'Quality',
}

export interface CategoryDto {
  label?: string | undefined
  details?: CategoryRowDto[] | undefined
}

export interface CategoryRowDto {
  label?: string | undefined
  quantity?: QuantityDto
}

export interface ChamberOfCommerceDto {
  number?: string | undefined
  branchNumber?: string | undefined
  country?: CountryDto
}

export interface ChangePartNameArgs {
  rowOrAssemblyId?: string
  partName?: string | undefined
  readonly isValid?: boolean
  readonly validationMessage?: string | undefined
  readonly validationDictionary?: { [key: string]: string } | undefined
}

export interface ChangeProjectOrderNumberArgs {
  orderNumber?: string | undefined
  readonly isValid?: boolean
  readonly validationMessage?: string | undefined
  readonly validationDictionary?: { [key: string]: string } | undefined
}

export interface ChangeProjectReferenceArgs {
  projectReference?: string | undefined
  readonly isValid?: boolean
  readonly validationMessage?: string | undefined
  readonly validationDictionary?: { [key: string]: string } | undefined
}

export interface ChangeQuantityArgs {
  quantity?: number
  readonly isValid?: boolean
  readonly validationMessage?: string | undefined
  readonly validationDictionary?: { [key: string]: string } | undefined
}

export interface ChangeSalesPersonRequest {
  userId?: string | undefined
}

export interface ChangeStatusAndPriorityArgs {
  initialStatus?: string | undefined
  targetStatus?: string | undefined
  position?: number
  readonly isValid?: boolean
  readonly validationMessage?: string | undefined
  readonly validationDictionary?: { [key: string]: string } | undefined
}

export interface ChangeTargetSalesPriceArgs {
  targetSalesPricePerItem?: MoneyDto
  id?: string
  readonly isValid?: boolean
  readonly validationMessage?: string | undefined
  readonly validationDictionary?: { [key: string]: string } | undefined
}

export interface ContactPersonDto {
  id?: string
  firstName?: string | undefined
  lastName?: string | undefined
  email?: string | undefined
  readonly fullName?: string | undefined
}

export interface CopyWorkingStepArgs {
  sourcePartTypeId: string
  destinationPartTypeIds: string[]
  workingStepType: WorkingStepType
}

export interface CountryDto {
  code?: string | undefined
  name?: string | undefined
}

export interface CreateProjectArgs {
  orderNumber?: string | undefined
  projectReference?: string | undefined
  buyerPartyDto?: PartyDto
  author?: User
  supplierId?: string
  state?: ProcessFlow
  vatRatio?: QuantityDto
  isBuyerParty?: boolean
  sellingPartyGlnNumber?: string | undefined
  buyingPartyGlnNumber?: string | undefined
  readonly isValid?: boolean
  readonly validationMessage?: string | undefined
  readonly validationDictionary?: { [key: string]: string } | undefined
}

export interface CreatorDto {
  firstName?: string | undefined
  lastName?: string | undefined
  email?: string | undefined
}

export interface CustomerPortalWorkingStepSettingsDto {
  workingStepType?: WorkingStepType
  availableInPortal?: boolean
  hiddenInPortal?: boolean
  notRemovableInPortal?: boolean
}

export interface CuttingPlanDetailsDto {
  index?: number
  quantity?: number
  offsetTop?: number
  offsetRight?: number
  offsetBottom?: number
  offsetLeft?: number
  partDistance?: number
  sheetLength?: number
  sheetWidth?: number
  nestedLength?: number
  nestedWidth?: number
  sheetUtilization?: number
  nestedSheetUtilization?: number
  uniquePartQuantity?: number
  totalPartQuantity?: number
  sheetArea?: number
  totalPartArea?: number
  nestableArea?: number
  offsettedSheetUtilization?: number
}

export interface CuttingPlanDto {
  id?: number
  quantity?: number
  fileNameOfNestingImage?: string | undefined
  details?: CuttingPlanDetailsDto
  partTypeIds?: string[] | undefined
  resourceId?: string
  articleId?: string | undefined
}

export interface CuttingPlanResult {
  id?: number
  imageFilename?: string | undefined
  imageData?: string | undefined
  quantity?: number
}

export interface DeleteGeometryOperationsResponse {
  isAcknowledged?: boolean
  deletedCount?: number
}

export interface DeletePartyCanBuyFromRequest {
  buyingPartyId?: string
  sellingPartyId?: string
}

export interface DeletePartyRequest {
  partyId?: string
}

export interface DeletePartyUserRequest {
  userId?: string | undefined
}

export interface DeleteProjectsArgs {
  projectIds?: string[] | undefined
}

export interface DeleteUserRequest {
  id?: string | undefined
}

export interface DeleteWorkingStepsArgs {
  itemIds?: string[] | undefined
  primaryWorkingStep?: WorkingStepType
  primaryWorkingStepsToDelete?: WorkingStepType[] | undefined
}

export interface DeliveryEstimationDto {
  numberOfDays?: number | undefined
}

export interface DimensionsDto {
  label?: string | undefined
  measureDto?: QuantityDto
}

export interface EmailDNSSettingsDto {
  active?: EmailSenderDto
  pending?: EmailSenderDto
}

export interface EmailDomainAuthenticationDnsRecordDto {
  valid?: boolean
  type?: string | undefined
  host?: string | undefined
  data?: string | undefined
}

export interface EmailDomainAuthenticationDto {
  domain?: string | undefined
  valid?: boolean
  dnsRecords?: EmailDomainAuthenticationDnsRecordDto[] | undefined
}

export interface EmailSenderDto {
  name?: string | undefined
  email?: string | undefined
  domainAuthentication?: EmailDomainAuthenticationDto
}

export interface EnableImnooRequest {
  apiToken?: string | undefined
}

export interface EventLogDto {
  dateTime?: Date
  channel?: string | undefined
  source?: string | undefined
  category?: string | undefined
  severity?: EventLogSeverityDto
  message?: string | undefined
}

export enum EventLogSeverityDto {
  Information = 'Information',
  Warning = 'Warning',
  Error = 'Error',
}

export interface ExportTemplateDto {
  id?: string
  fileName?: string | undefined
  name?: string | undefined
  description?: string | undefined
  createdAt?: Date
  updatedAt?: Date
}

export interface ExportTemplateDtoArrayApiResponse {
  records?: ExportTemplateDto[][] | undefined
  _meta?: ApiMetadata
}

export interface FinancialDto {
  id?: string
  quantity?: number
  totalProjectQuantity?: number
  costPricePerItem?: MoneyDto
  costPriceOfItems?: MoneyDto
  salesPricePerItem?: MoneyDto
  salesPriceOfItems?: MoneyDto
  targetSalesPricePerItem?: MoneyDto
  discountRatio?: QuantityDto
  discountValuePerItem?: MoneyDto
  discountValueOfItems?: MoneyDto
  surchargeRatio?: QuantityDto
  surchargeValuePerItem?: MoneyDto
  surchargeValueOfItems?: MoneyDto
}

export interface FittingDataDto {
  producedPartDto?: ProducedPartDto
  partPropertiesDto?: PartPropertiesDto
  stepFileName?: string | undefined
  geometryPartName?: string | undefined
}

export interface GeometryFileDetails {
  file?: string | undefined
  quantity?: number
  thickness?: number
  tokens?: string[] | undefined
  comment?: string | undefined
}

export interface GetCustomersWithAccessResponse {
  customers?: SelectableCustomerDto[] | undefined
}

export interface GetGeometryOperationsResponse {
  totalQueued?: number
  totalStarted?: number
  totalFinished?: number
  totalFailed?: number
  records?: ProjectOperationDto[] | undefined
  _meta?: ApiMetadata
}

export interface GetNestingEngineResponse {
  nestingEngine?: string | undefined
}

export interface GetOperationSummaryResponse {
  isNesting?: boolean
  isExportingToErp?: boolean
  isManufacturabilityCheckRunning?: boolean
}

export interface GetPredictedProductionTimeResponse {
  originalFilename?: string | undefined
  results?: PredictionResult[] | undefined
}

export interface GetProjectEstimationTemplateResponse {
  lastUpdatedAt?: Date | undefined
  fileName?: string | undefined
}

export interface GetProjectOperationsResponse {
  totalQueued?: number
  totalStarted?: number
  totalFinished?: number
  totalFailed?: number
  records?: ProjectOperationDto[] | undefined
  _meta?: ApiMetadata
}

export interface GetProjectSummariesResponse {
  projectList?: ProjectSummaryDto[] | undefined
  projectStates?: string[] | undefined
}

export interface GetProjectSummariesResponsePaged {
  projectStates?: string[] | undefined
  page?: number
  pageSize?: number
  totalCount?: number
  details?: ProjectSummaryDto[] | undefined
  _links?: PagingLinks
  _sortFields?: string[] | undefined
}

export interface GetRemovedProjectSummariesResponse {
  projectList?: ProjectSummaryDto[] | undefined
  projectStates?: string[] | undefined
}

export interface GetSelectableCustomersResponse {
  customers?: SelectableCustomerDto[] | undefined
}

export enum GrossPriceSource {
  NotInitialized = 'NotInitialized',
  CatalogPrice = 'CatalogPrice',
  HousePrice = 'HousePrice',
  CloudPrice = 'CloudPrice',
}

export interface GroupPartTypeIdsArgs {
  assemblyId?: string
  partIds?: string[] | undefined
  readonly isValid?: boolean
  readonly validationMessage?: string | undefined
  readonly validationDictionary?: { [key: string]: string } | undefined
}

export interface ImnooAvailableResourceDto {
  id?: string
  name?: string | undefined
}

export interface ImnooDto {
  enabled?: boolean
  apiToken?: string | undefined
  resourceMappings?: ImnooResourceMappingDto[] | undefined
  materialMappings?: ImnooMaterialMappingDto[] | undefined
  availableMaterials?: string[] | undefined
  availableImnooMaterials?: string[] | undefined
  availableResources?: ImnooAvailableResourceDto[] | undefined
  availableImnooResources?: ImnooAvailableResourceDto[] | undefined
  usePartNameAsArticleNumber?: boolean
  useBuyingPartyPrefixInArticleName?: boolean
  autofillArticleWithTwoDDrawingData?: boolean
}

export interface ImnooGetAvailableMaterialResponse {
  availableMaterials?: string[] | undefined
  availableImnooMaterials?: string[] | undefined
}

export interface ImnooMaterialMappingDto {
  keyword?: string | undefined
  imnooMaterialName?: string | undefined
}

export interface ImnooMaterialMappingModel {
  keyword?: string | undefined
  imnooMaterialName?: string | undefined
}

export interface ImnooResourceMappingDto {
  resourceId?: string
  resourceName?: string | undefined
  imnooMachineId?: string
}

export interface ImnooResourceMappingModel {
  resourceId?: string
  imnooMachineId?: string
}

export interface InsertOrUpdateTemplateArgs {
  file?: string | undefined
  languageCode?: string | undefined
}

export interface IntegrationDto {
  id?: string
  name?: string | undefined
  enabled?: boolean
}

export interface IntegrationSettingDto {
  name?: string | undefined
  hidden?: boolean
  required?: boolean
  value?: any | undefined
  valueType?: IntegrationSettingDtoValueType
}

export enum IntegrationSettingDtoValueType {
  Number = 'Number',
  Text = 'Text',
}

export enum IntegrationType {
  NotInitialized = 'NotInitialized',
  ERP_ECI_RidderIQ = 'ERP_ECI_RidderIQ',
  CAM_LVD_CadmanB = 'CAM_LVD_CadmanB',
  CAM_WiCAM_PN4000 = 'CAM_WiCAM_PN4000',
  CAM_BySoft_CAM = 'CAM_BySoft_CAM',
  ERP_ISAH_ISAH = 'ERP_ISAH_ISAH',
  CAM_Trumpf_TruTops_Boost = 'CAM_Trumpf_TruTops_Boost',
  MES_Trumpf_TruTops_Fab = 'MES_Trumpf_TruTops_Fab',
  ERP_ECI_Bemet = 'ERP_ECI_Bemet',
  Custom = 'Custom',
  ERP_Lantek_Integra = 'ERP_Lantek_Integra',
  FCC_AutoPOL = 'FCC_AutoPOL',
  CAM_LVD_CadmanSdi = 'CAM_LVD_CadmanSdi',
  ERP_MKG_V3 = 'ERP_MKG_V3',
  ERP_MKG_V4 = 'ERP_MKG_V4',
  ERP_MKG_V5 = 'ERP_MKG_V5',
}

export interface InvitationDto {
  id?: string
  firstName?: string | undefined
  lastName?: string | undefined
  email?: string | undefined
  dateCreated?: Date
  inviteLink?: string | undefined
}

export enum IssueCategory {
  NotInitialized = 'NotInitialized',
  Geometry = 'Geometry',
  Activity = 'Activity',
  Workflow = 'Workflow',
  Estimation = 'Estimation',
}

export enum IssueCode {
  NotInitialized = 'NotInitialized',
  MaterialNotSet = 'MaterialNotSet',
  WorkingStepNotSet = 'WorkingStepNotSet',
  MaterialCostPriceNotSet = 'MaterialCostPriceNotSet',
  WorkingStepCostPriceNotSet = 'WorkingStepCostPriceNotSet',
  ResourceNotSet = 'ResourceNotSet',
  EstimationNotValid = 'EstimationNotValid',
  OuterContour2dNotSet = 'OuterContour2dNotSet',
  ProductionTimeNotSet = 'ProductionTimeNotSet',
  ManufacturabilityCheckFailed = 'ManufacturabilityCheckFailed',
  ExportToErpFailed = 'ExportToErpFailed',
  PartDoesNotFitInMaterial = 'PartDoesNotFitInMaterial',
  Other = 'Other',
  MaterialAndManualCostPriceNotSet = 'MaterialAndManualCostPriceNotSet',
  MultipleArticlesFound = 'MultipleArticlesFound',
  AnalysisFailed = 'AnalysisFailed',
  NestingFailed = 'NestingFailed',
  WorkingStepNotAvailable = 'WorkingStepNotAvailable',
  SheetCuttingToolPathsMissing = 'SheetCuttingToolPathsMissing',
}

export interface IssueDto {
  id?: string
  description?: string | undefined
  category?: IssueCategory
  categoryDescription?: string | undefined
  severity?: IssueSeverity
  severityDescription?: string | undefined
  type?: IssueType
  issueCode?: IssueCode
  typeDescription?: string | undefined
  aggregateLevel?: AggregateLevel
  itemId?: string
  timestamp?: Date
  metadata?: any | undefined
}

export enum IssueSeverity {
  NotInitialized = 'NotInitialized',
  None = 'None',
  Warning = 'Warning',
  Error = 'Error',
  NotManufacturable = 'NotManufacturable',
}

export enum IssueType {
  NotInitialized = 'NotInitialized',
  ServerError = 'ServerError',
  IncompleteInput = 'IncompleteInput',
  Manufacturability = 'Manufacturability',
  IncompleteOutput = 'IncompleteOutput',
}

export interface ItemDetailDto {
  itemId?: string
  categories?: CategoryDto[] | undefined
  prices?: PriceRowDto[] | undefined
}

export interface JsonSchema {
  $schema?: string | undefined
  id?: string | undefined
  title?: string | undefined
  type?: any | undefined
  discriminator?: any | undefined
  description?: string | undefined
  format?: string | undefined
  default?: any | undefined
  multipleOf?: number | undefined
  maximum?: number | undefined
  minimum?: number | undefined
  maxLength?: number | undefined
  minLength?: number | undefined
  pattern?: string | undefined
  maxItems?: number
  minItems?: number
  uniqueItems?: boolean
  maxProperties?: number
  minProperties?: number
  'x-deprecated'?: boolean
  'x-deprecatedMessage'?: string | undefined
  'x-abstract'?: boolean
  'x-nullable'?: boolean | undefined
  'x-example'?: any | undefined
  'x-enumFlags'?: boolean
  'x-dictionaryKey'?: JsonSchema
  xml?: JsonXmlObject
  not?: JsonSchema
  exclusiveMaximum?: any | undefined
  exclusiveMinimum?: any | undefined
  additionalItems?: any | undefined
  additionalProperties?: any | undefined
  items?: any | undefined
  required?: string[]
  properties?: { [key: string]: JsonSchemaProperty }
  patternProperties?: { [key: string]: JsonSchemaProperty }
  definitions?: { [key: string]: JsonSchema }
  'x-enumNames'?: string[]
  enum?: (any | undefined)[]
  allOf?: JsonSchema[]
  anyOf?: JsonSchema[]
  oneOf?: JsonSchema[]
  $ref?: string

  [key: string]: any
}

export interface JsonSchemaObjects {
  schema?: JsonSchema
  uiSchema?: JsonSchema
}

export interface JsonSchemaProperty {
  $schema?: string | undefined
  id?: string | undefined
  title?: string | undefined
  type?: any | undefined
  discriminator?: any | undefined
  'x-readOnly'?: boolean
  'x-writeOnly'?: boolean
  description?: string | undefined
  format?: string | undefined
  default?: any | undefined
  multipleOf?: number | undefined
  maximum?: number | undefined
  minimum?: number | undefined
  maxLength?: number | undefined
  minLength?: number | undefined
  pattern?: string | undefined
  maxItems?: number
  minItems?: number
  uniqueItems?: boolean
  maxProperties?: number
  minProperties?: number
  'x-deprecated'?: boolean
  'x-deprecatedMessage'?: string | undefined
  'x-abstract'?: boolean
  'x-nullable'?: boolean | undefined
  'x-example'?: any | undefined
  'x-enumFlags'?: boolean
  'x-dictionaryKey'?: JsonSchema
  xml?: JsonXmlObject
  not?: JsonSchema
  exclusiveMaximum?: any | undefined
  exclusiveMinimum?: any | undefined
  additionalItems?: any | undefined
  additionalProperties?: any | undefined
  items?: any | undefined
  required?: string[]
  properties?: { [key: string]: JsonSchemaProperty }
  patternProperties?: { [key: string]: JsonSchemaProperty }
  definitions?: { [key: string]: JsonSchema }
  'x-enumNames'?: string[]
  enum?: (any | undefined)[]
  allOf?: JsonSchema[]
  anyOf?: JsonSchema[]
  oneOf?: JsonSchema[]
  $ref?: string

  [key: string]: any
}

export interface JsonXmlObject {
  name?: string | undefined
  wrapped?: boolean
  namespace?: string | undefined
  prefix?: string | undefined
  attribute?: boolean
}

export enum KPI {
  ResponseTime = 'ResponseTime',
  NegotiationTime = 'NegotiationTime',
  SalesLeadTime = 'SalesLeadTime',
  ConversionRate = 'ConversionRate',
}

export interface KPITarget {
  kpi?: KPI
  value?: number
  unit?: string | undefined
}

export interface KeywordDto {
  originalKeyword?: string | undefined
  category?: string | undefined
  translationKey?: string | undefined
  translationArgument?: any | undefined
}

export interface KeywordGroupDto {
  keywordGroups?: { [key: string]: KeywordDto[] } | undefined
}

export interface LanguageDto {
  code?: string | undefined
  description?: string | undefined
}

export interface MachineLearningRecord {
  partName?: string | undefined
  resourceType?: string | undefined
  productionTime?: number | undefined
  material?: string | undefined
  densityInKilogramsPerCubicMeter?: number | undefined
  dimWeightValue?: number | undefined
  dimLength3DValue?: number | undefined
  dimHeight3DValue?: number | undefined
  dimWidth3DValue?: number | undefined
  dimPartVolumeValue?: number | undefined
  dimNetAreaValue?: number | undefined
  dimLength2DValue?: number | undefined
  dimWidth2DValue?: number | undefined
  dimThicknessValue?: number | undefined
  numberOfBendGroups?: number | undefined
  numberOfBendGroupsSide1?: number | undefined
  numberOfBendGroupsSide2?: number | undefined
  bendXTurns?: number | undefined
  bendYTurns?: number | undefined
  bendZTurns?: number | undefined
  stepFileName?: string | undefined
}

export interface MachineLearningRecordSearchResponse {
  isFilterEmpty?: boolean
  isFilterValid?: boolean
  invalidData?: string | undefined
  recordCount?: number
  records?: MachineLearningRecord[] | undefined
}

export interface MachiningSettingsArgs {
  roundBarMinimumOffset: QuantityDto
  roundBarMaximumOffset: QuantityDto
  squareBarMinimumOffset: QuantityDto
  squareBarMaximumOffset: QuantityDto
  machiningPartLenghtPercentage: QuantityDto
}

export interface MachiningSettingsDto {
  roundBarMinimumOffset?: QuantityDto
  roundBarMaximumOffset?: QuantityDto
  squareBarMinimumOffset?: QuantityDto
  squareBarMaximumOffset?: QuantityDto
  machiningPartLenghtPercentage?: QuantityDto
}

export interface MainStandardDto {
  name?: string | undefined
  materialNumbers?: MaterialNumberDto[] | undefined
}

export interface ManagementPartyDto {
  id?: string
  name?: string | undefined
  currencyCode?: string | undefined
  coCKey?: string | undefined
  hasSubscription?: boolean
}

export interface ManuallySetAdditionalCostsArgs {
  primaryWorkingStep?: WorkingStepType
  secondaryWorkingStep?: WorkingStepType
  additionalCosts?: MoneyDto
  priceScope?: PriceScope
}

export interface ManuallySetProductionTimeArgs {
  primaryWorkingStep?: WorkingStepType
  secondaryWorkingStep?: WorkingStepType
  productionTime?: QuantityDto
  priceScope?: PriceScope
}

export interface MaterialHeaderDto {
  id?: string | undefined
  materialSummary?: MaterialSummaryDto
  workingStepDtos?: WorkingStepDto[] | undefined
  cuttingPlans?: CuttingPlanDto[] | undefined
  price?: MoneyPerQuantityDto
  priceSource?: GrossPriceSource
  partTypeIds?: string[] | undefined
  supportsRemnantCustomization?: boolean
}

export interface MaterialNumberDto {
  materialNumber?: string | undefined
  standards?: StandardDto[] | undefined
}

export interface MaterialScaledDiscountDto {
  quantity?: QuantityDto
  percentage?: QuantityDto
}

export interface MaterialScaledDiscountsAndSurchargesDto {
  material?: string | undefined
  scaledDiscounts?: MaterialScaledDiscountDto[] | undefined
  segmentedDiscounts?: SegmentedMaterialScaledDiscountsDto[] | undefined
  scaledSurcharges?: MaterialScaledSurchargeDto[] | undefined
}

export interface MaterialScaledSurchargeDto {
  quantity?: QuantityDto
  percentage?: QuantityDto
}

export interface MaterialSelectorDto {
  selectableTokens?: { [key: string]: KeywordDto[] } | undefined
  selectedTokens?: KeywordDto[] | undefined
  materials?: MaterialSummaryDto[] | undefined
  selectedMaterial?: MaterialSummaryDto
}

export interface MaterialSummaryDto {
  id?: string | undefined
  description?: string | undefined
  shallSelectSide?: boolean
  sideId?: number
  shallHaveSelectedDirection?: boolean
  threeDModelSideOne?: string | undefined
  threeDModelSideTwo?: string | undefined
  tokens?: { [key: string]: KeywordDto[] } | undefined
}

export interface MaterialsAndStandardsDto {
  materialGroup?: string | undefined
  mainStandards?: MainStandardDto[] | undefined
}

export interface MenuItem {
  id?: string | undefined
  displayName?: string | undefined
  sourceName?: string | undefined
  description?: string | undefined
}

export interface MissingDataDto {
  stepFileName?: string | undefined
  geometryPartName?: string | undefined
}

export interface Money {
  value?: number
  currency?: string | undefined
  symbol?: string | undefined
}

export interface MoneyDto {
  value?: number
  currency?: string | undefined
  symbol?: string | undefined
}

export interface MoneyPerQuantityDto {
  money?: MoneyDto
  quantity?: QuantityDto
}

export interface NestingCommercialSettingsArgs {
  nestingCommercialSettingsDto?: NestingCommercialSettingsDto
  readonly isValid?: boolean
  readonly validationMessage?: string | undefined
  readonly validationDictionary?: { [key: string]: string } | undefined
}

export interface NestingCommercialSettingsDto {
  selectedSize?: NestingSize
  selectableSizes?: NestingSize[] | undefined
  shapeType?: ShapeType
}

export enum NestingDirection {
  NotInitialized = 'NotInitialized',
  Free = 'Free',
  X = 'X',
  Y = 'Y',
}

export interface NestingParamsDto {
  distanceBetweenParts?: QuantityDto
  topOffset?: QuantityDto
  bottomOffset?: QuantityDto
  leftOffset?: QuantityDto
  rightOffset?: QuantityDto
  remnantType?: NestingRemnantType
  nestingRemnantWidth?: QuantityDto
  nestingRemnantArea?: QuantityDto
  maxTimeLimit?: QuantityDto
  preferedMaterialWidth?: QuantityDto
  preferedMaterialLength?: QuantityDto
  preferedMaterialHeight?: QuantityDto
}

export enum NestingRemnantType {
  NoRemnant = 'NoRemnant',
  CleanCut = 'CleanCut',
  CleanCutHorizontal = 'CleanCutHorizontal',
  CleanCutVertical = 'CleanCutVertical',
  Rectangular = 'Rectangular',
}

export enum NestingRemnantTypeV2 {
  NoRemnant = 'NoRemnant',
  CleanCut = 'CleanCut',
  CleanCutHorizontal = 'CleanCutHorizontal',
  CleanCutVertical = 'CleanCutVertical',
  Rectangular = 'Rectangular',
  TrueShape = 'TrueShape',
}

export interface NestingResult {
  materialId?: string | undefined
  resourceId?: string
  remnantSettings?: RemnantSettings
  cuttingPlans?: CuttingPlanResult[] | undefined
}

export interface NestingSize {
  length?: QuantityDto
  height?: QuantityDto
}

export interface NewTemplateRequest {
  name?: string | undefined
  description?: string | undefined
  file?: string | undefined
}

export enum NotificationType {
  Info = 'Info',
  Warning = 'Warning',
  Danger = 'Danger',
}

export interface PagingLinks {
  current?: string | undefined
  next?: string | undefined
  previous?: string | undefined
}

export interface PartPropertiesDto {
  dimLength3DValue?: number | undefined
  dimHeight3DValue?: number | undefined
  dimWidth3DValue?: number | undefined
  dimPartVolumeValue?: number | undefined
  dimNetAreaValue?: number | undefined
  dimLength2DValue?: number | undefined
  dimWidth2DValue?: number | undefined
  dimThicknessValue?: number | undefined
  bending?: BendingDto
}

export interface PartyCanBuyFromDto {
  id?: string
  name?: string | undefined
}

export interface PartyDto {
  partyId?: string
  relationId?: string
  coCCode?: string | undefined
  address?: AddressDto
  legalName?: string | undefined
  contactPerson?: ContactPersonDto
  vatRatio?: QuantityDto
  chamberOfCommerce?: ChamberOfCommerceDto
  vatNumber?: string | undefined
  bicOrSwiftCode?: string | undefined
  iban?: string | undefined
  languageCode?: string | undefined
  languageDescription?: string | undefined
}

export interface PartyDxfSettingsDto {
  addUnfoldedDXFAsAttachment?: boolean
  colors?: string[] | undefined
}

export interface PartyInviteDto {
  id?: string
  buyerPartyId?: string
  buyerPartyName?: string | undefined
  firstName?: string | undefined
  lastName?: string | undefined
  email?: string | undefined
  dateCreated?: Date
  status?: PartyInviteDtoStatus
}

export enum PartyInviteDtoStatus {
  New = 'New',
  Accepted = 'Accepted',
}

export interface PartyProfileDto {
  legalName?: string | undefined
  address?: AddressDto
  chamberOfCommerce?: ChamberOfCommerceDto
  vatNumber?: string | undefined
  bicOrSwiftCode?: string | undefined
  iban?: string | undefined
}

export interface PartySearchResult {
  readonly searchKey?: string | undefined
  id?: string
  coCCode?: string | undefined
  addresses?: string[] | undefined
  names?: string[] | undefined
}

export interface PartySegmentDto {
  id?: string
  name?: string | undefined
}

export interface PartySummaryDto {
  id?: string
  name?: string | undefined
  isBuyingParty?: boolean
  showBeamerNotifications?: boolean
}

export interface PartyUserDto {
  id?: string | undefined
  fullName?: string | undefined
  firstName?: string | undefined
  lastName?: string | undefined
  email?: string | undefined
  emailVerified?: boolean | undefined
  picture?: string | undefined
  role?: string | undefined
  isSysAdmin?: boolean
}

export interface PartyUserResetPasswordRequest {
  emailAddress?: string | undefined
  userId?: string | undefined
}

export interface PortalInfo {
  companyName?: string | undefined
  url?: string | undefined
}

export interface PortalSettings {
  url?: string | undefined
  shallBeamNotifications?: boolean
}

export interface PredictionResult {
  partName?: string | undefined
  productionTime?: number
}

export interface PriceRowDto {
  description?: string | undefined
  costPrice?: MoneyDto
  productionTimeCosts?: MoneyDto
  costPriceIsManuallySet?: boolean
  discountValue?: MoneyDto
  surchargeValue?: MoneyDto
  discountRatio?: QuantityDto
  surchargeRatio?: QuantityDto
  salesPrice?: MoneyDto
  canObtainExplanation?: boolean
  isWorkingStep?: boolean
  workingStep?: WorkingStepDto
  isTotalRow?: boolean
  productionTime?: QuantityDto
  productionTimeManuallySet?: QuantityDto
  additionalProductionCosts?: MoneyDto
  additionalProductionCostsManuallySet?: MoneyDto
  costsAreShared?: boolean
  rate?: MoneyPerQuantityDto
  canManualEditCostPrice?: boolean
  canManualEditSurchargeDiscount?: boolean
  isBatchIndependent?: boolean
}

export enum PriceScope {
  NotInitialized = 'NotInitialized',
  Unit = 'Unit',
  Batch = 'Batch',
  Total = 'Total',
}

export interface PriceSummaryCostPriceDto {
  quantity?: QuantityDto
  price?: MoneyPerQuantityDto
  selected?: boolean
}

export interface PriceSummaryDto {
  rate?: MoneyPerQuantityDto
  totalCostPrice?: MoneyDto
  productionTimeCosts?: MoneyDto
  additionalCosts?: MoneyDto
  description?: string | undefined
  isMaterial?: boolean
  isWorkingStep?: boolean
  workingStep?: WorkingStepDto
  materialId?: string | undefined
  discountValue?: MoneyDto
  surchargeValue?: MoneyDto
  discountRatio?: QuantityDto
  surchargeRatio?: QuantityDto
  productionTime?: QuantityDto
  weight?: QuantityDto
  isDiscountManuallySet?: boolean
  isSurchargeManuallySet?: boolean
  isCostPriceManuallySet?: boolean
  totalSalesPrice?: MoneyDto
  costsAreShared?: boolean
  isPurchasePart?: boolean
  isPurchasePartWithoutArticle?: boolean
  staggeredCostPrices?: PriceSummaryCostPriceDto[] | undefined
  totalQuantity?: QuantityDto
  staggeredQuantity?: QuantityDto
  staggeredTotalQuantity?: QuantityDto
  canEditDiscountOrSurcharge?: boolean
}

export interface ProblemDetails {
  type?: string | undefined
  title?: string | undefined
  status?: number | undefined
  detail?: string | undefined
  instance?: string | undefined

  [key: string]: any
}

export enum ProcessFlow {
  NotInitialized = 'NotInitialized',
  Automated = 'Automated',
  Manual = 'Manual',
  TemporarilyManuallyProcess = 'TemporarilyManuallyProcess',
}

export interface ProducedPartDto {
  partName?: string | undefined
  resourceId?: string
  resourceType?: string | undefined
  productionTime?: number | undefined
  material?: string | undefined
  densityInKilogramsPerCubicMeter?: number
  dimWeightValue?: number | undefined
}

export interface ProgressInformation {
  description?: string | undefined
  progress?: number | undefined
  notificationType?: NotificationType
}

export interface ProjectCreator {
  firstName?: string | undefined
  lastName?: string | undefined
  email?: string | undefined
}

export interface ProjectDto {
  isBuyingPartyView?: boolean
  id?: string
  projectReference?: string | undefined
  orderNumber?: string | undefined
  boM?: BoMDto
  financial?: ProjectFinancialDto
  buyingParty?: PartyDto
  sellingParty?: PartyDto
  sellingPartyId?: string
  status?: string | undefined
  processFlowState?: string | undefined
  workingSteps?: WorkingStepDto[] | undefined
  attachments?: BoMItemAttachmentDto[] | undefined
  isManufacturable?: boolean
  manufacturableStatus?: string | undefined
  manufacturableResult?: string | undefined
  isExportedToErp?: boolean
  exportedToErpStatus?: string | undefined
  exportedToErpResult?: string | undefined
  externalUrl?: string | undefined
  createdOn?: Date | undefined
  createdBy?: CreatorDto
  salesPerson?: SalesPersonDto
  comment?: string | undefined
  nestingQueueCount?: number
  readonly canNest?: boolean
  definingInPortal?: boolean
  feasibleDeliveryDate?: Date | undefined
  requestedDeliveryDate?: Date | undefined
  deliveryEstimation?: DeliveryEstimationDto
}

export interface ProjectExportTemplateDto {
  id?: string
  name?: string | undefined
  description?: string | undefined
}

export interface ProjectFinancialDto {
  id?: string
  quantity?: number
  totalProjectQuantity?: number
  costPricePerItem?: MoneyDto
  costPriceOfItems?: MoneyDto
  salesPricePerItem?: MoneyDto
  salesPriceOfItems?: MoneyDto
  targetSalesPricePerItem?: MoneyDto
  discountRatio?: QuantityDto
  discountValuePerItem?: MoneyDto
  discountValueOfItems?: MoneyDto
  surchargeRatio?: QuantityDto
  surchargeValuePerItem?: MoneyDto
  surchargeValueOfItems?: MoneyDto
  salesPriceInclVatPerItem?: MoneyDto
  salesPriceInclVatOfItems?: MoneyDto
  vatRatio?: QuantityDto
  vatValueOfItems?: MoneyDto
}

export interface ProjectOperationDto {
  id?: string
  operationTypeTranslationKey?: string | undefined
  operationTypeTranslationArguments?: (any | undefined)[] | undefined
  lastUpdatedAt?: Date | undefined
  createdBy?: string | undefined
  errorMessage?: string | undefined
  status?: ProjectOperationStatus
  boMItemId?: string | undefined
  children?: ProjectOperationDto[] | undefined
  readonly totalChildrenCount?: number | undefined
  readonly totalChildrenFailedCount?: number | undefined
  readonly totalChildrenFinishedCount?: number | undefined
}

export enum ProjectOperationStatus {
  Queued = 'Queued',
  Started = 'Started',
  Finished = 'Finished',
  Failed = 'Failed',
}

export interface ProjectPriorityArgs {
  priority?: number
  readonly isValid?: boolean
  readonly validationMessage?: string | undefined
  readonly validationDictionary?: { [key: string]: string } | undefined
}

export interface ProjectSalesPerson {
  firstName?: string | undefined
  lastName?: string | undefined
  email?: string | undefined
}

export interface ProjectSimplifyDto {
  assemblySimplifyDtos?: AssemblySimplifyDto[] | undefined
}

export enum ProjectStates {
  NotInitialized = 'NotInitialized',
  Defining = 'Defining',
  Requested = 'Requested',
  Quoting = 'Quoting',
  Quoted = 'Quoted',
  Negotiating = 'Negotiating',
  Ordered = 'Ordered',
  Producing = 'Producing',
  Produced = 'Produced',
  Packaging = 'Packaging',
  Packaged = 'Packaged',
  Delivering = 'Delivering',
  Delivered = 'Delivered',
  Cancelled = 'Cancelled',
}

export interface ProjectStatusChangedEmailTemplate {
  options?: ProjectStatusChangedEmailTemplateOptions
  design?: string | undefined
  html?: string | undefined
  emailSubject?: string | undefined
}

export interface ProjectStatusChangedEmailTemplateOptions {
  projectStatus?: string | undefined
  sendToEmailAsBcc?: string | undefined
  sendToProjectAuthor?: boolean
  sendToProjectContactPerson?: boolean
  sendToSalesAgentAsCC?: boolean
  sendToMainBuyerPartyContactPersonAsCC?: boolean
  enabledForPortalOnly?: boolean
  subject?: string | undefined
}

export interface ProjectSummaryDto {
  id?: string
  projectReference?: string | undefined
  orderNumber?: string | undefined
  status?: string | undefined
  numberOfItems?: number
  lastOperation?: Date
  priority?: number
  buyingPartyName?: string | undefined
  sellingPartyName?: string | undefined
  numberOfRows?: number
  salesPriceOfItems?: Money
  buyingPartyId?: string
  sellingPartyId?: string
  creator?: ProjectCreator
  salesPerson?: ProjectSalesPerson
  removedOn?: Date
}

export interface PurchasePriceDto {
  keywords?: { [key: string]: KeywordDto[] } | undefined
  purchasingData?: PurchasingDataDto
  code?: string | undefined
  description?: string | undefined
}

export interface PurchasePricesDto {
  isEditable?: boolean
  purchasePrices?: PurchasePriceDto[] | undefined
}

export interface PurchasingDataDto {
  grossPriceUpdatedOn?: Date
  grossPrices?: PurchasingDataGrossPriceDto[] | undefined
  preferredSupplier?: SellingPartyType
  defaultPurchasingQuantity?: QuantityDto
  grossPriceSource?: GrossPriceSource
}

export interface PurchasingDataGrossPriceDto {
  quantity?: QuantityDto
  price?: MoneyPerQuantityDto
}

export enum PurchasingDimensions {
  NotInitialized = 'NotInitialized',
  Length = 'Length',
  Width = 'Width',
  Height = 'Height',
}

export interface PurchasingPriceItemArgs {
  keywords?: string[] | undefined
  purchasingData?: PurchasingDataDto
  readonly isValid?: boolean
  readonly validationMessage?: string | undefined
  readonly validationDictionary?: { [key: string]: string } | undefined
}

export interface QuantityDto {
  value?: number
  unit?: string | undefined
  selectableAbbreviations?: string[] | undefined
}

export interface QuotationDetailsDto {
  projectReference?: string | undefined
  clientName?: string | undefined
  contactPerson?: ContactPersonDto
  selectableContactPersons?: ContactPersonDto[] | undefined
  deliveryAddress?: AddressDto
  postalAddress?: AddressDto
  selectableAddresses?: AddressDto[] | undefined
  quotationHeaderText?: string | undefined
  quotationFooterText?: string | undefined
  deliveryDate?: string | undefined
  deliveryDays?: number
  quotationDate?: Date
  showParts?: boolean
  showPriceDetails?: boolean
  vatRatio?: QuantityDto
  languageCode?: string | undefined
  languageDescription?: string | undefined
  selectableLanguages?: LanguageDto[] | undefined
}

export interface RememberBomItemAsPurchasingPartArgs {
  shallRemember?: boolean
  projectId?: string
  itemId?: string
  articleId?: string | undefined
}

export interface RemnantSettings {
  remnantType?: NestingRemnantTypeV2
  minimumWidth?: number
  minimumArea?: number
}

export interface RemoveKeywordFromRowsArgs {
  rowIds: string[]
  keyword: string
}

export interface RepairProjectAnalysisStatusesRequest {
  projectId?: string
}

export interface RepairProjectAnalysisStatusesResponse {
  success?: boolean
}

export interface ResendInviteRequest {
  invitationId?: string
}

export interface ResendInviteResponse {
  invitationId?: string
}

export interface ResourceDto {
  id?: string | undefined
  name?: string | undefined
  isDefault?: boolean
  activities?: ActivityDto[] | undefined
  isOutsourced?: boolean
  readonly hasNestableActivities?: boolean
  nestingParams?: NestingParamsDto
}

export enum ResourceMatchType {
  NotInitialized = 'NotInitialized',
  NoCapableResources = 'NoCapableResources',
  OneCapableResource = 'OneCapableResource',
  BestOfMultipleCapableResources = 'BestOfMultipleCapableResources',
  OneOfMultipleCapableResources = 'OneOfMultipleCapableResources',
}

export interface ResourceSummaryDto {
  id?: string | undefined
  name?: string | undefined
  workingStepType?: WorkingStepType
  isOutsourced?: boolean
}

export interface ResourceWorkingStepManualDiscountArgs {
  discountRatio?: QuantityDto
  discountValue?: MoneyDto
  readonly isValid?: boolean
  readonly validationMessage?: string | undefined
  readonly validationDictionary?: { [key: string]: string } | undefined
}

export interface ResourceWorkingStepManualSurchargeArgs {
  surchargeRatio?: QuantityDto
  surchargeValue?: MoneyDto
  readonly isValid?: boolean
  readonly validationMessage?: string | undefined
  readonly validationDictionary?: { [key: string]: string } | undefined
}

export interface RestoreRemovedProjectArgs {
  projectIds?: string[] | undefined
}

export interface RestoreRemovedProjectsResponse {
  isSuccess?: boolean
}

export interface RevokeAccessRequest {
  buyingPartyId?: string
  relationId?: string
}

export interface RevokeInviteRequest {
  inviteId?: string
}

export interface RhTenantInfo {
  id?: string | undefined
  identifier?: string | undefined
  name?: string | undefined
  connectionString?: string | undefined
  partyId?: string
}

export interface RoutingHeaderDto {
  id?: string | undefined
  workingStepDtos?: WorkingStepDto[] | undefined
  partTypeIds?: string[] | undefined
}

export interface RowDto {
  id?: string
  parentId?: string
  materialSummary?: MaterialSummaryDto
  rowNumber?: number
  name?: string | undefined
  dimensionsSummary?: string | undefined
  workingSteps?: WorkingStepDto[] | undefined
  thumbnail3d?: string | undefined
  thumbnail2d?: string | undefined
  has2dThumbnail?: boolean
  threeDModelPath?: string | undefined
  twoDModelPath?: string | undefined
  financial?: FinancialDto
  isCertificateNeeded?: boolean
  canChangeQuantity?: boolean
  progressInformation?: ProgressInformation
  selectedSideId?: number
  issues?: IssueDto[] | undefined
  selectableNestingDirections?: NestingDirection[] | undefined
  selectedNestingDirection?: NestingDirection
  isPurchasingBomItem?: boolean
  isRememberedPurchasingBoMItem?: boolean
  attachments?: BoMItemAttachmentDto[] | undefined
  originalFileName?: string | undefined
  isManufacturable?: boolean
  manufacturableStatus?: string | undefined
  manufacturableResult?: string | undefined
  isExportedToErp?: boolean
  exportedToErpStatus?: string | undefined
  exportedToErpResult?: string | undefined
  externalUrl?: string | undefined
  canManualEditCostPrice?: boolean
  comment?: string | undefined
  analysisStatus?: string | undefined
  analysisErrorMessage?: string | undefined
  canBeEdit?: boolean
  solvedIssues?: IssueCode[] | undefined
}

export interface RuleEditorClientSettings {
  editorData?: string | undefined
  sourceData?: string | undefined
  readonly rules?: MenuItem[] | undefined
}

export interface SalesPerson {
  userId?: string | undefined
  firstName?: string | undefined
  lastName?: string | undefined
  email?: string | undefined
  picture?: string | undefined
}

export interface SalesPersonDto {
  firstName?: string | undefined
  lastName?: string | undefined
  email?: string | undefined
}

export interface ScoringRequest {
  numberOfBendGroups?: number
  numberOfBendGroupsSide1?: number
  numberOfBendGroupsSide2?: number
  bendXTurns?: number
  bendYTurns?: number
  bendZTurns?: number
  dimLength3DValue?: number
  dimHeight3DValue?: number
  dimWidth3DValue?: number
  dimPartVolumeValue?: number
  dimNetAreaValue?: number
  dimLength2DValue?: number
  dimWidth2DValue?: number
  dimThicknessValue?: number
  material?: string | undefined
  densityInKilogramsPerCubicMeter?: number
  dimWeightValue?: number
}

export interface SegmentedMaterialScaledDiscountDto {
  quantity?: QuantityDto
  percentage?: QuantityDto
}

export interface SegmentedMaterialScaledDiscountsDto {
  material?: string | undefined
  segmentId?: string
  segmentName?: string | undefined
  scaledDiscounts?: SegmentedMaterialScaledDiscountDto[] | undefined
}

export interface SegmentedWorkingStepScaledDiscountDto {
  duration?: QuantityDto
  percentage?: QuantityDto
}

export interface SegmentedWorkingStepScaledDiscountsDto {
  workingStepType?: WorkingStepType
  segmentId?: string
  segmentName?: string | undefined
  scaledDiscounts?: SegmentedWorkingStepScaledDiscountDto[] | undefined
}

export interface SelectableCustomerDto {
  partyId?: string
  companyName?: string | undefined
  address?: string | undefined
  contactPersonFirstName?: string | undefined
  contactPersonLastName?: string | undefined
  email?: string | undefined
}

export interface SelectedResourceDto {
  id?: string
  name?: string | undefined
  matchType?: ResourceMatchType
  readonly matchDescription?: string | undefined
}

export interface SellingPartyDto {
  id?: string
  legalName?: string | undefined
}

export enum SellingPartyType {
  NotInitialized = 'NotInitialized',
  MCB = 'MCB',
}

export interface SendInviteRequest {
  firstName?: string | undefined
  lastName?: string | undefined
  email?: string | undefined
  buyerPartyId?: string
  relationId?: string
}

export interface SendInviteResponse {
  invitationId?: string
}

export interface SetCurrencyRequest {
  currencyCode?: string | undefined
}

export interface SetCustomerPortalWorkingStepRequest {
  workingStepType?: WorkingStepType
  availableInPortal?: boolean
  hiddenInPortal?: boolean
  notRemovableInPortal?: boolean
}

export interface SetCustomerPortalWorkingStepsRequest {
  availableWorkingStepTypes?: WorkingStepType[] | undefined
  hiddenWorkingStepTypes?: WorkingStepType[] | undefined
  notRemovableWorkingStepTypes?: WorkingStepType[] | undefined
}

export interface SetEmailAddressRequest {
  name?: string | undefined
  emailAddress?: string | undefined
}

export interface SetFeasibleDeliveryDateRequest {
  feasibleDeliveryDate?: Date
}

export interface SetImnooIntegrationSettingsRequest {
  usePartNameAsArticleNumber?: boolean
  useBuyingPartyNamePrefixInArticleName?: boolean
  autofillArticleWithDrawingData?: boolean
}

export interface SetImnooMaterialMappingsRequest {
  mappings?: ImnooMaterialMappingModel[] | undefined
}

export interface SetImnooResourceMappingsRequest {
  mappings?: ImnooResourceMappingModel[] | undefined
}

export interface SetKPITargetArgs {
  value?: QuantityDto
  kpi?: KPI
}

export interface SetKeywordsOrArticleToPartsArgs {
  rowIds?: string[] | undefined
  articleId?: string | undefined
  keywords?: string[] | undefined
  readonly isValid?: boolean
  readonly validationMessage?: string | undefined
  readonly validationDictionary?: { [key: string]: string } | undefined
}

export interface SetMaterialCostPriceArgs {
  costPrice?: MoneyDto
  priceScope?: PriceScope
}

export interface SetNestingDirectionArgs {
  nestingDirection?: NestingDirection
}

export interface SetNestingEngineRequest {
  nestingEngine?: string | undefined
}

export interface SetRequestedDeliveryDateRequest {
  requestedDeliveryDate?: Date
}

export interface SetSelectedResourceArgs {
  boMItemIds?: string[] | undefined
  resourceId?: string
  workingStepType?: WorkingStepType
}

export enum ShapeType {
  Unknown = 'Unknown',
  Sheet = 'Sheet',
  FlatBar = 'FlatBar',
  RoundBar = 'RoundBar',
  SquareBar = 'SquareBar',
  HexagonalBar = 'HexagonalBar',
  RectangularBar = 'RectangularBar',
  TBar = 'TBar',
  HalfRoundBar = 'HalfRoundBar',
  CBeam = 'CBeam',
  RoundTube = 'RoundTube',
  SquareOrRectangularTube = 'SquareOrRectangularTube',
  OvalTube = 'OvalTube',
  LBeam = 'LBeam',
  HBeam = 'HBeam',
  IBeam = 'IBeam',
  UBeam = 'UBeam',
  TBeam = 'TBeam',
  Part = 'Part',
}

export enum ShareRatioBy {
  NotInitialized = 'NotInitialized',
  CostPrice = 'CostPrice',
  Weight = 'Weight',
  Volume = 'Volume',
  Area2d = 'Area2d',
  NumberOfPartsUnique = 'NumberOfPartsUnique',
  NumberOfPartsTotalProjectAmount = 'NumberOfPartsTotalProjectAmount',
  NumberOfUniqueMaterialsDividedOverParts = 'NumberOfUniqueMaterialsDividedOverParts',
}

export interface ShowDetailsDto {
  templateType?: TemplateType
  showDetails?: boolean
}

export interface SolveIssuesArgs {
  bomItemIds?: string[] | undefined
  issueCodes?: IssueCode[] | undefined
}

export interface StandardDto {
  name?: string | undefined
  keywords?: StandardKeywordDto[] | undefined
}

export interface StandardKeywordDto {
  name?: string | undefined
  isSelected?: boolean
  relatedStandard?: string | undefined
}

export enum TemplateType {
  NotInitialized = 'NotInitialized',
  Quotation = 'Quotation',
  Order = 'Order',
  Invoice = 'Invoice',
  BillOfMaterials = 'BillOfMaterials',
  BillOfLabor = 'BillOfLabor',
}

export interface TemplateTypeDto {
  type?: TemplateType
  languageCode?: string | undefined
  languageDescription?: string | undefined
}

export interface UIError {
  message?: string | undefined
}

export interface UnassignPartyRoleRequest {
  userId?: string | undefined
  role?: string | undefined
  partyId?: string
}

export interface UnassignSystemRoleRequest {
  userId?: string | undefined
  role?: string | undefined
}

export interface UpdateActivityArgs {
  activity?: ActivityDto
  readonly isValid?: boolean
  readonly validationMessage?: string | undefined
  readonly validationDictionary?: { [key: string]: string } | undefined
}

export interface UpdateAgentArgs {
  name?: string | undefined
  agent?: AgentDto
  readonly isValid?: boolean
  readonly validationMessage?: string | undefined
  readonly validationDictionary?: { [key: string]: string } | undefined
}

export interface UpdateAgentIntegrationArgs {
  integration?: AgentIntegrationDto
  readonly isValid?: boolean
  readonly validationMessage?: string | undefined
  readonly validationDictionary?: { [key: string]: string } | undefined
}

export interface UpdateBeamNotificationsRequest {
  shallBeamNotifications?: boolean
}

export interface UpdateBomItemCommentRequest {
  comment?: string | undefined
}

export interface UpdateMaterialScaledDiscountModel {
  quantity?: QuantityDto
  percentage?: QuantityDto
}

export interface UpdateMaterialScaledDiscountsAndSurchargesRequest {
  material?: string | undefined
  scaledDiscounts?: UpdateMaterialScaledDiscountModel[] | undefined
  segmentedScaledDiscounts?:
    | UpdateSegmentedMaterialScaledDiscountsModel[]
    | undefined
  scaledSurcharges?: UpdateMaterialScaledSurchargeModel[] | undefined
}

export interface UpdateMaterialScaledSurchargeModel {
  quantity?: QuantityDto
  percentage?: QuantityDto
}

export interface UpdatePartyRequest {
  partyId?: string
  name?: string | undefined
  coCKey?: string | undefined
  hasSubscription?: boolean | undefined
}

export interface UpdatePartyUserRequest {
  userId?: string | undefined
  firstName?: string | undefined
  lastName?: string | undefined
  fullName?: string | undefined
}

export interface UpdatePartyUserRoleRequest {
  userId?: string | undefined
  role?: string | undefined
}

export interface UpdatePortalUrlRequest {
  url?: string | undefined
}

export interface UpdateResourceArgs {
  name?: string | undefined
  isOutsourced?: boolean
  nestingParamsDto?: NestingParamsDto
  readonly isValid?: boolean
  readonly validationMessage?: string | undefined
  readonly validationDictionary?: { [key: string]: string } | undefined
}

export interface UpdateSegmentWorkingStepDiscountUnitOfMeasureRequest {
  abbreviation?: string | undefined
}

export interface UpdateSegmentedMaterialScaledDiscountModel {
  quantity?: QuantityDto
  percentage?: QuantityDto
}

export interface UpdateSegmentedMaterialScaledDiscountsModel {
  segmentId?: string
  scaledDiscounts?: UpdateSegmentedMaterialScaledDiscountModel[] | undefined
}

export interface UpdateSegmentedWorkingStepScaledDiscountModel {
  duration?: QuantityDto
  percentage?: QuantityDto
}

export interface UpdateSegmentedWorkingStepScaledDiscountsModel {
  segmentId?: string
  scaledDiscounts?: UpdateSegmentedWorkingStepScaledDiscountModel[] | undefined
}

export interface UpdateTemplateRequest {
  id?: string
  name?: string | undefined
  description?: string | undefined
  file?: string | undefined
}

export interface UpdateTenantRequest {
  name?: string | undefined
  partyId?: string
}

export interface UpdateUserRequest {
  id?: string | undefined
  firstName?: string | undefined
  lastName?: string | undefined
  fullName?: string | undefined
}

export interface UpdateWorkingStepDiscountUnitOfMeasureRequest {
  abbreviation?: string | undefined
}

export interface UpdateWorkingStepScaledDiscountModel {
  duration?: QuantityDto
  percentage?: QuantityDto
}

export interface UpdateWorkingStepScaledDiscountsAndSurchargesRequest {
  scaledDiscounts?: UpdateWorkingStepScaledDiscountModel[] | undefined
  segmentedScaledDiscounts?:
    | UpdateSegmentedWorkingStepScaledDiscountsModel[]
    | undefined
  scaledSurcharges?: UpdateWorkingStepScaledSurchargeModel[] | undefined
}

export interface UpdateWorkingStepScaledSurchargeModel {
  duration?: QuantityDto
  percentage?: QuantityDto
}

export interface UpdateWorkingStepSurchargeUnitOfMeasureRequest {
  abbreviation?: string | undefined
}

export interface User {
  auth0Id?: string | undefined
  firstName?: string | undefined
  lastName?: string | undefined
  email?: string | undefined
  picture?: string | undefined
}

export interface UserDto {
  picture?: string | undefined
  email?: string | undefined
  email_verified?: boolean
  company?: string | undefined
  firstName?: string | undefined
  lastName?: string | undefined
  readonly fullName?: string | undefined
  readonly partiesDto?: PartySummaryDto[] | undefined
  availablePortals?: PortalInfo[] | undefined
}

export interface VerifyDomainAuthenticationResponse {
  active?: EmailSenderDto
  pending?: EmailSenderDto
}

export interface Werk24Dto {
  enabled?: boolean
}

export interface WorkingStepDto {
  primaryWorkingStep?: WorkingStepType
  secondaryWorkingStep?: WorkingStepType
  resource?: SelectedResourceDto
  readonly key?: string | undefined
  isPrimaryWorkingStep?: boolean
  usesRawMaterial?: boolean
  notRemovable?: boolean
}

export interface WorkingStepKey {
  primaryWorkingStep?: WorkingStepType
  secondaryWorkingStep?: WorkingStepType
}

export interface WorkingStepScaledDiscountDto {
  duration?: QuantityDto
  percentage?: QuantityDto
}

export interface WorkingStepScaledDiscountsAndSurchargesDto {
  workingStep?: WorkingStepType
  scaledDiscounts?: WorkingStepScaledDiscountDto[] | undefined
  segmentedDiscounts?: SegmentedWorkingStepScaledDiscountsDto[] | undefined
  scaledSurcharges?: WorkingStepScaledSurchargeDto[] | undefined
}

export interface WorkingStepScaledSurchargeDto {
  duration?: QuantityDto
  percentage?: QuantityDto
}

export enum WorkingStepType {
  NotInitialized = 'NotInitialized',
  SheetCutting = 'SheetCutting',
  Sawing = 'Sawing',
  SheetBending = 'SheetBending',
  CounterSinking = 'CounterSinking',
  Milling = 'Milling',
  TubeOrProfileCutting = 'TubeOrProfileCutting',
  Turning = 'Turning',
  Purchasing = 'Purchasing',
  Engraving = 'Engraving',
  ThreadTapping = 'ThreadTapping',
  Anodising = 'Anodising',
  Assembling = 'Assembling',
  BoltPressing = 'BoltPressing',
  Deburring = 'Deburring',
  Drilling = 'Drilling',
  EdgeMilling = 'EdgeMilling',
  EdgeTrimming = 'EdgeTrimming',
  LevelTensioning = 'LevelTensioning',
  NutPressing = 'NutPressing',
  PicklingPassivating = 'PicklingPassivating',
  Polishing = 'Polishing',
  PowderCoating = 'PowderCoating',
  Punching = 'Punching',
  Rolling = 'Rolling',
  StudWelding = 'StudWelding',
  TubeProfileOrBarBending = 'TubeProfileOrBarBending',
  Welding = 'Welding',
  ZincPlating = 'ZincPlating',
  Designing = 'Designing',
  Loading = 'Loading',
  Unloading = 'Unloading',
  SheetShearing = 'SheetShearing',
  Setup = 'Setup',
  Certifying = 'Certifying',
  Shipping = 'Shipping',
  Programming = 'Programming',
  OrderPicking = 'OrderPicking',
  Packaging = 'Packaging',
  BeadBlasting = 'BeadBlasting',
  SandBlasting = 'SandBlasting',
  SteelGridBlasting = 'SteelGridBlasting',
  WetBlasting = 'WetBlasting',
  VacuumBlasting = 'VacuumBlasting',
  CentrifugalBlasting = 'CentrifugalBlasting',
  SodaBlasting = 'SodaBlasting',
  BristleBlasting = 'BristleBlasting',
  DryIceBlasting = 'DryIceBlasting',
  PencilBlasting = 'PencilBlasting',
  WeldGrinding = 'WeldGrinding',
  RobotWelding = 'RobotWelding',
  RobotStudWelding = 'RobotStudWelding',
  Nitriding = 'Nitriding',
  DieSinking = 'DieSinking',
  WireErosion = 'WireErosion',
  Hemming = 'Hemming',
  VibratoryDeburring = 'VibratoryDeburring',
  Foiling = 'Foiling',
  Cleaning = 'Cleaning',
  QualityControlling = 'QualityControlling',
  ElectrolyticPolishing = 'ElectrolyticPolishing',
  CathodicDipCoating = 'CathodicDipCoating',
  ElectrophoreticDipCoating = 'ElectrophoreticDipCoating',
  FlowDrilling = 'FlowDrilling',
  HoleProtectioning = 'HoleProtectioning',
  Operating = 'Operating',
  Researching = 'Researching',
}

export interface WorkingStepsArgs {
  itemIds?: string[] | undefined
  formData?: any | undefined
  workingStepDto?: WorkingStepDto
  readonly isValid?: boolean
  readonly validationMessage?: string | undefined
  readonly validationDictionary?: { [key: string]: string } | undefined
}

export interface WorkingStepsDto {
  selectedWorkingSteps?: WorkingStepDto[] | undefined
  availableWorkingSteps?: WorkingStepDto[] | undefined
}

export interface FileParameter {
  data: any
  fileName: string
}

export interface FileResponse {
  data: Blob
  status: number
  fileName?: string
  headers?: { [name: string]: any }
}
